import CircleBorder, { User as _User} from './CircleBorder';
export type User = _User;
export default CircleBorder;